import React from "react";
import "../../style/loginForm.css";
import { NavLink } from "react-router-dom";

export default function LoginForm() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Login Submitted");
  };

  return (
    <form id="signInForm" className="login-form" onSubmit={handleSubmit}>
      <h1 className="form-title">Welcome, Login In</h1>

      <div className="form-row">
        <label htmlFor="email">Email:</label>
        <input
          type="text"
          id="email"
          name="email"
          placeholder="UserName"
          required
        />
      </div>

      <div className="form-row">
        <label htmlFor="password">Password:</label>
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          required
        />
      </div>

      <div className="form-actions">
        <button type="submit" className="btn-primary">
          Login
        </button>

        <NavLink to="/register" className="btn-primary new-user">
          New User
        </NavLink>
      </div>
    </form>
  );
}